import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FormGroupSelect, NestedFieldSet } from "components/formElements";
import { SkillDropdowns, CurrentCompany } from "components/formGroups";
import { getOptions, getYearsOfExperience } from "util/library";
import Select from 'react-select';
import { getReactSelectOptions, CustomPlaceholder, customStyles } from "util/library";
const MoreThanOneYear = ({
  handleChange,
  skills,
  yearsOfExperience,
  ...rest
}) => (
  <Fragment>
    <NestedFieldSet legendText="Experience">
      {/*<FormGroupSelect*/}
      {/*  id="yearsOfExperience"*/}
      {/*  name="yearsOfExperience"*/}
      {/*  label="Years of Experience"*/}
      {/*  value={yearsOfExperience}*/}
      {/*  onChange={handleChange}*/}
      {/*  required*/}
      {/*  options={getOptions(*/}
      {/*    getYearsOfExperience(),*/}
      {/*    "Select Years of Experience*"*/}
      {/*  )}*/}
            {/*/>*/}
                <Select
                    id="yearsOfExperience"
                    name="yearsOfExperience"
                    options={getReactSelectOptions(getYearsOfExperience())}
                    value={getReactSelectOptions(getYearsOfExperience()).find(
                        (opt) => opt.value === yearsOfExperience
                    )}
                    onChange={(selected) =>
                        handleChange({
                            target: { name: "yearsOfExperience", value: selected ? selected.value : "" },
                        })
                    }
                    placeholder={<CustomPlaceholder text="Select Years of Experience" />}
                    styles={customStyles}
                    isClearable={true} // required field, so no clearing allowed
                />

      <CurrentCompany handleChange={handleChange} {...rest} />
    </NestedFieldSet>
    <SkillDropdowns
      handleChange={handleChange}
      skills={skills}
      required
      {...rest}
    />
    {rest.noticePeriodFields}
  </Fragment>
);

MoreThanOneYear.propTypes = {
  handleChange: PropTypes.func.isRequired,
  skills: PropTypes.array.isRequired,
};

export { MoreThanOneYear };
